import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ChatService } from 'src/app/services/chat.service';

@Component({
  selector: 'app-verification-code',
  templateUrl: './verification-code.component.html',
  styleUrls: ['./verification-code.component.css']
})
export class VerificationCodeComponent implements OnInit {

  codeValidateForm!: FormGroup;
  entityLogo!: string;
  submited: boolean = false;
  isDisabled: boolean = false;

  /**
   * Confirm Otp Verification
   */
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: true,
    placeholder: '',
    inputStyles: {
      'width': '22%',
      'height': '60px'
    }
  };
  btnDisabled: boolean = true;
  resendDisabled: boolean = false;
  resendTime: number = 30;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private chatService: ChatService
  ) { }

  ngOnInit(): void {
    // if (!localStorage.getItem('otp-app-pending')) {
    //   this.router.navigateByUrl('/account/login');
    // }
    const entityData: any = localStorage.getItem('entityData');
    this.entityLogo = JSON.parse(entityData).logo;
    this.codeValidateForm = this.formBuilder.group({
      code: ['', Validators.required],
    });
  }

  get form() {
    return this.codeValidateForm.controls;
  }

  onOtpChange(ev: any) {
    this.codeValidateForm.controls['code'].setValue(ev);
    if (ev.length === 4) {
      this.btnDisabled = false;
    } else {
      this.btnDisabled = true;
    }
  }

  submitCode() {
    this.submited = true;
    if (this.codeValidateForm.valid) {
      this.isDisabled = true;
      this.authService
        .validateLoginCode(this.form['code'].value)
        .subscribe({
          next: (result: any) => {
            if (result.success === true) {
              this.authService.getUser().subscribe((user) => {
                this.isDisabled = false;
                localStorage.removeItem('otp-app-pending');
                localStorage.removeItem('code_req_app');
                this.authService.saveUserToLocalStorage(user);
                // this.chatService.openConnection(user);
                this.isDisabled = false;
                this.submited = false;
                this.router.navigateByUrl('/');
              });
            } else if (result.success === false) {
              this.isDisabled = false;
              this.codeValidateForm.controls['code'].setErrors({
                codeError: true,
              });
            }
          },
          error: (err: any) => {
            this.isDisabled = false;
            this.codeValidateForm.controls['code'].setErrors({
              codeError: true,
            });
          },
        });
    }
  }

  resendCode() {
    this.authService.resendVerificationCode().subscribe(() => {
      this.resendDisabled = true;
      const interval = setInterval(() => {
        if (this.resendTime === 1) {
          this.resendDisabled = false;
          this.resendTime = 30;
          clearInterval(interval);
        } else {
          this.resendTime--;
        }
      }, 1000);
    });
  }

}
